import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

const styles = {
  container: {
    display: "flex",
    justifyContent: "flex-end"
  }
};

const CurrencyCell = props => (
  <td className={props.className}>
    <div className={props.classes.container}>
      <div>$</div>
      <div>{props.children}</div>
    </div>
  </td>
);

CurrencyCell.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default withStyles(styles)(CurrencyCell);
